import { put, call, take, fork } from 'redux-saga/effects'
import { AICreatorUploadAttachmentService } from '../../api/ai-creator'
import { aICreatorUploadAttachmentSuccess } from '../../reducers/ai-creator/action'
import { UPLOAD_ATTACHMENT } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* uploadAttachmentFlow(payload) {
  try {
    const { formData, fileName, callback } = payload

    const response = yield call(AICreatorUploadAttachmentService, formData)

    yield put(aICreatorUploadAttachmentSuccess(response, fileName))
    yield put(operationSuccess())
    if (callback) callback(response)
  } catch (error) {
    yield put(operationFail(error))
    // Hata durumunda da callback'i çağır
    const { callback } = payload
    if (callback) callback(null, error)
  }
}

/**
 *
 */
export default function* aICreatorUploadAttachmentWatcher() {
  while (true) {
    const action = yield take(UPLOAD_ATTACHMENT)
    const { payload } = action

    yield fork(generalSaga, uploadAttachmentFlow, payload, false)
  }
}
